import {
  setLoadingConfigObject,
  shimmerPlaceholderConfig,
} from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils'

import styles from './AppointmentCardLoading.Config.Styles'

const loadingConfig = theme => [
  {
    right: setLoadingConfigObject('square', 1, null, styles.cancelBooking),
  },
  {
    main: setLoadingConfigObject('circle', 1, 80, styles.serviceIcon),
  },
  {
    main: setLoadingConfigObject('square', 1, null, styles.serviceTitle),
  },
  {
    style: styles.storeContainer(theme),
    left: setLoadingConfigObject('circle', 1, 40, styles.storeIcon),
    main: setLoadingConfigObject('square', 4, null, styles.storeDetails),
  },

  {
    main: setLoadingConfigObject('square', 1, null, styles.date),
  },
  {
    main: [
      'row',
      setLoadingConfigObject('square', 1, null, styles.changeBookingBtn),
      setLoadingConfigObject('square', 1, null, styles.storeDirectionBtn),
    ],
  },
]

export { loadingConfig, shimmerPlaceholderConfig }
